import {
  Component,
  effect,
  inject,
  input,
  ViewEncapsulation
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TargetedAdService } from './targeted-ad.service';

/**
 * The Targeted Ad Component
 *
 * This component is responsible for creating a targeted ad on the page
 */
@Component({
  selector: 'td-wb-targeted-ad',
  templateUrl: 'targeted-ad.component.html',
  styleUrls: ['targeted-ad.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.td-wb-targeted-ad--visible]': 'visible'
  }
})
export class TargetedAdComponent {
  private readonly targetedAdService = inject(TargetedAdService);
  private readonly onLoad = toSignal(this.targetedAdService.onLoad, { initialValue: false });

  /**
   * The page where the targeted ad is going to be located
   */
  readonly targetId = input<string | undefined>(undefined);

  protected visible: boolean = false;

  constructor() {
    effect((): void => {
      const targetId = this.targetId();
      if (targetId === undefined) {
        this.visible = false;
        return;
      }

      const isLoaded = this.onLoad();
      this.visible = isLoaded;

      if (isLoaded) {
        this.targetedAdService.getTargetedAd(targetId);
      }
    });
  }
}
